import RentalTripCard from './RentalTripCardContainer';

export default RentalTripCard;
